import React from 'react';

const LEGEND_ITEMS = [
    { color: '#3b82f6', label: 'Early-Race' },
    { color: '#22c55e', label: 'Mid-Race' },
    { color: '#f97316', label: 'Late-Race' },
    { color: '#ef4444', label: 'Last Spurt' },
    { color: '#facc15', label: 'Corner', opacity: 0.55 },
    { color: '#f87171', label: 'Slope Up', opacity: 0.7 },
    { color: '#60a5fa', label: 'Slope Down', opacity: 0.7 },
    { color: '#a855f7', label: 'Spurt Zone', opacity: 0.4 },
    { color: '#34d399', label: 'Straight', opacity: 0.7 },
];

/**
 * CourseMapLegend
 * Compact horizontal legend chips for the course map.
 */
const CourseMapLegend = () => (
    <div className="flex flex-wrap gap-2 mt-3">
        {LEGEND_ITEMS.map(({ color, label, opacity = 1 }) => (
            <div key={label} className="flex items-center gap-1.5 text-xs text-gray-400">
                <span
                    className="inline-block w-3 h-3 rounded-sm flex-shrink-0"
                    style={{ backgroundColor: color, opacity }}
                />
                <span className="font-mono">{label}</span>
            </div>
        ))}
    </div>
);

export default CourseMapLegend;
